import { render, staticRenderFns } from "./EventNotes.vue?vue&type=template&id=769ddc31&"
import script from "./EventNotes.vue?vue&type=script&lang=js&"
export * from "./EventNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports